var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgY(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.343 2.472c0 .336-.144.792-.432 1.368L21.855 25.944V48.84c0 .624-.216 1.152-.648 1.584-.432.384-.96.576-1.584.576-.624 0-1.152-.192-1.584-.576-.384-.432-.576-.96-.576-1.584V26.016L1.335 3.984a2.205 2.205 0 01-.576-1.512c0-.576.24-1.08.72-1.512.48-.432 1.008-.648 1.584-.648.768 0 1.368.336 1.8 1.008l14.904 20.304L34.31 1.32C34.839.648 35.463.312 36.183.312c.576 0 1.08.24 1.512.72.432.432.648.912.648 1.44z",
    fill: "currentColor"
  })));
}
export default SvgY;